import React, { createContext, useContext } from 'react';

const TranslatorContext = createContext(key => key);

export const TranslatorProvider = ({ children }) => {
	const translations = JSON.parse(process.env.GATSBY_TRANSLATOR);

	function translate(string) {
		if (typeof string !== 'string') {
			return undefined;
		}

		return translations?.[string] ?? string;
	}

	return <TranslatorContext.Provider value={translate}>{children}</TranslatorContext.Provider>;
};

export const useTranslator = () => {
	return useContext(TranslatorContext);
};
